/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocalTime } from './localTime';


export interface HappyHourDto { 
    dayOfWeek?: HappyHourDto.DayOfWeekEnum;
    startTime?: LocalTime;
    endTime?: LocalTime;
}
export namespace HappyHourDto {
    export type DayOfWeekEnum = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
    export const DayOfWeekEnum = {
        Monday: 'MONDAY' as DayOfWeekEnum,
        Tuesday: 'TUESDAY' as DayOfWeekEnum,
        Wednesday: 'WEDNESDAY' as DayOfWeekEnum,
        Thursday: 'THURSDAY' as DayOfWeekEnum,
        Friday: 'FRIDAY' as DayOfWeekEnum,
        Saturday: 'SATURDAY' as DayOfWeekEnum,
        Sunday: 'SUNDAY' as DayOfWeekEnum
    };
}


